import React from "react";
import styles from "../Home/Award/Award.module.scss";

interface AwardsCardProps {
  awardImage: string;
  imgAlt: string;
  imgTitle: string;
  description: string;
}

const AwardsCard: React.FC<AwardsCardProps> = ({
  awardImage,
  imgAlt,
  imgTitle,
  description,
}) => {
  return (
    <div
      className={`${styles.awardCardDiv} d-flex flex-column justify-content-start`}
    >
      <img
        src={awardImage}
        alt={imgAlt}
        title={imgTitle}
        className={styles.awardsImage}
      />
      <p
        className={`para2 ${styles.description}`}
        dangerouslySetInnerHTML={{ __html: description }}
      ></p>
    </div>
  );
};

export default AwardsCard;
